export enum CompressionSubSamplingEnum {
  YUV444,
  YUV422,
  YUV420
}
